import type { AgentType } from "@/services/studio/types";

export function AgentTypeBadge({ type }: { type: AgentType | string }) {
  const isActionable = type === "actionable";
  return (
    <span
      className={[
        "inline-flex items-center rounded-full px-2 py-0.5 font-mono text-[10px] font-semibold",
        isActionable
          ? "bg-[hsl(var(--accent-warm)/0.15)] text-[hsl(var(--accent-warm))]"
          : "bg-primary/10 text-primary",
      ].join(" ")}
    >
      {isActionable ? "Actionable" : "Queryable"}
    </span>
  );
}
